export default "__VITE_PUBLIC_ASSET__be348c69__"